import React, { useState, useEffect } from 'react';

import { makeStyles, Container, Grid, Paper, IconButton } from '@material-ui/core';
import BreadCrumb from 'app/components/BreadCrumb';
import CustomPaginationActionsTable from 'app/components/TableList/TableList';
import { injectIntl } from 'react-intl';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';

import styles from './styles';
import { fetchInfractions } from 'app/store/slices/company';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { errorHandler } from 'app/utils/errorHandler';
import { hideLoading, showLoading } from 'app/store/slices/settings';
import daesEndpoint from 'app/api/services/daesEndpoint';
const useStyles = makeStyles(styles);

function InfractionsList(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({});
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rows, setRows] = useState([]);

  const [filters, setFilters] = useState({});

  const infractions = useSelector(state => state.company.infractions);

  const { intl } = props;

  const columns = [
    { title: 'A. de Infração', field: 'cdAutoInfracao', align: 'left' },
    { title: 'Data auto', field: 'dtHrInfracao', align: 'left' },
    { title: 'Tipo de Infração', field: 'nmArtigo', align: 'left' },
    { title: 'Grupo', field: 'deGrupo', align: 'left' },
    { title: 'Cod. Inf.', field: 'cdInfracao', align: 'left' },
    { title: 'Situação', field: 'deSituacao', align: 'left' },
    { title: 'Valor', field: 'vlInfracao', align: 'left' },
    { title: 'Data Vencimento', field: 'dtVencimento', align: 'left' },
    { title: '', field: 'document', align: 'left' },
  ];

  const prepareData = content => {
    return {
      originalData: content,
      cdAutoInfracao: <>{content.cdAutoInfracao}</>,
      dtHrInfracao: <>{moment.utc(content.dtHrInfracao).format('DD/MM/YYYY')}</>,
      nmArtigo: <>{content.nmArtigo}</>,
      deGrupo: <>{content.deGrupo ? content.deGrupo : '-'}</>,
      cdInfracao: <>{content.cdInfracao ? content.cdInfracao : '-'}</>,
      deSituacao: <>{content.deSituacao}</>,
      vlInfracao: (
        <>
          {!content.vlInfracao || content.vlInfracao === 0
            ? '-'
            : Number(content.vlInfracao).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}
        </>
      ),
      dtVencimento: (
        <>{content.dtVencimento ? moment.utc(content.dtVencimento).format('DD/MM/YYYY') : '-'}</>
      ),
      document: (
        <>
          {content.nuGru && content.nuGru !== '' ? (
            <IconButton color="primary" className={classes.iconDocument} size="small">
              <InsertDriveFileIcon className={classes.icon} />
            </IconButton>
          ) : (
            <></>
          )}
        </>
      ),
    };
  };

  useEffect(() => {
    setLoading(true);
    const findRequests = async () => {
      try {
        const search = { page: page, size: pageSize, request: { ...filters } };
        await dispatch(fetchInfractions(search));
      } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
      }
      setLoading(false);
    };
    findRequests();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, filters, page, pageSize]);

  useEffect(() => {
    const rows = [];
    if (infractions.content) {
      infractions.content.forEach(cont => {
        rows.push(prepareData(cont));
      });
    }
    setRows(rows);
    setPagination(infractions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [infractions]);

  const handleChangeFilter = (key, value) => {
    const temp = { ...filters };
    temp[key] = value;
    setFilters(temp);
  };

  const onChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const onChangeRowsPerPage = event => {
    setPageSize(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onBlurSearch = event => {
    handleChangeFilter('txtBusca', event.target.value);
    setPage(0);
  };

  const handleClickRow = async (e, row) => {
    if (row.originalData) {
      dispatch(showLoading());
      try {
        const localOriginalData = row.originalData;
        if (localOriginalData.nuAnoGru && localOriginalData.nuGru) {
          const response = await daesEndpoint.showDAE(
            localOriginalData.nuAnoGru,
            localOriginalData.nuGru,
            localOriginalData.nuDocumento
          );
          if (response.status === 200 && response.data) {
            const downloadLink = document.createElement('a');
            downloadLink.target = '_blank';
            downloadLink.download = 'DAE.pdf';

            const blob = new Blob([response.data], { type: 'application/pdf' });

            const URL = window.URL || window.webkitURL;
            const downloadUrl = URL.createObjectURL(blob);

            downloadLink.href = downloadUrl;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            URL.revokeObjectURL(downloadUrl);
          }
        }
      } catch (error) {
        console.error(error);
      }
      dispatch(hideLoading());
    }
  };

  const onChangeSearch = event => {};

  const breadCrumb = [
    {
      title: intl.formatMessage({ id: 'LABELS.INFRACTIONS.INFRACTIONS' }),
      path: '',
    },
  ];

  return (
    <Container>
      <BreadCrumb breadCrumb={breadCrumb} />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.container} elevation={3}>
            <CustomPaginationActionsTable
              loading={loading}
              columns={columns}
              rows={rows}
              placeholderSearch="Busca"
              pagination={pagination}
              onChangePage={onChangePage}
              onChangeRowsPerPage={onChangeRowsPerPage}
              onBlurSearch={onBlurSearch}
              onChangeSearch={onChangeSearch}
              onClickRow={handleClickRow}
              hideOrder={true}
              hideItemOrder={true}
              hideInitialDate={true}
              hideFinalDate={true}
            />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default injectIntl(InfractionsList);
